import { Edit } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { ApiClientForm } from "./ApiClientForm";

interface Props {}

export const ApiClientEdit = (props: Props) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-api-clients.title.edit">
      <ApiClientForm isEdit />
    </Edit>
  );
};
